const SCROLL_THRESHOLD = 10;

/**
 * Scroll direction detection throttled via requestAnimationFrame.
 */
class Scroll {
  constructor(onDirectionChange, rootEl) {
    this.onDirectionChange = onDirectionChange;
    this.lastScrollTop = window.scrollY;
    this.headerHeight = rootEl.clientHeight;
    this.accumulatedDelta = 0;
    this.direction = 'up';
    this.ticking = false;

    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  handleScroll = () => {
    if (!this.ticking) {
      this.ticking = true;
      requestAnimationFrame(this.update);
    }
  };

  update = () => {
    const scrollTop = window.scrollY;
    const delta = scrollTop - this.lastScrollTop;

    if (scrollTop <= this.headerHeight) {
      this.setDirection('up');
      this.accumulatedDelta = 0;
    } else {
      this.accumulatedDelta += delta;

      if (this.accumulatedDelta > SCROLL_THRESHOLD) {
        this.setDirection('down');
        this.accumulatedDelta = 0;
      } else if (this.accumulatedDelta < -SCROLL_THRESHOLD) {
        this.setDirection('up');
        this.accumulatedDelta = 0;
      }
    }

    this.lastScrollTop = scrollTop;
    this.ticking = false;
  };

  setDirection(direction) {
    if (this.direction === direction) {
      return;
    }

    this.direction = direction;
    this.onDirectionChange(direction);
  }

  destroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}

export default Scroll;
